import React, { Suspense, useEffect, useState } from 'react';

import { Typography, IconButton } from '@material-ui/core';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import CommonAlert from 'components/CommonAlert/CommonAlert';
import ProductTransference from 'components/Dialogs/ProductTransference';
import WriteOffReleases from 'components/Dialogs/WriteOffReleases';
import TitleHead from 'components/TitleHead';
import Layout from 'containers/layouts/layout';
import BoxCount from 'images/icons/menu-items/boxCount.svg';
import BoxDropCasualties from 'images/icons/menu-items/boxDropCasualties.svg';
import BoxProduce from 'images/icons/menu-items/boxProduce.svg';
import BoxLabelProducts from 'images/icons/menu-items/boxLabelProducts.svg';
import BoxLabelScan from 'images/icons/menu-items/boxLabelScan.svg';
import BoxLabelPrinting from 'images/icons/menu-items/boxLabelPrinting.svg';
import BoxToReceive from 'images/icons/menu-items/boxToReceive.svg';
import BoxTransfer from 'images/icons/menu-items/boxTransfer.svg';
import LabelPrintConfigDialog from 'modules/labelPrinting/pages/catalog/products/dialogs/LabelPrintConfigDialog';
import PrintQrCodeScannerDialog from 'modules/labelPrinting/pages/catalog/products/dialogs/PrintQrCodeScannerDialog';

import * as UserActions from 'store/actions/user';
import { Container, GlobalStyle } from 'styles/general';
import ValidityProductCards from '../labelHome/components/ValidityProductCards';
import Axios from 'axios';
import Environment from 'utils/environments';
import BoxProduceIcon from 'images/icons/components/boxProduceIcon';
import BoxCountIcon from 'images/icons/components/boxCountIcon';
import BoxToReceiveIcon from 'images/icons/components/boxToReceiveIcon';
import BoxDropCasualtiesIcon from 'images/icons/components/boxDropCasualtiesIcon';
import BoxTransferIcon from 'images/icons/components/boxTransferIcon';
import BoxLabelProductsIcon from 'images/icons/components/boxLabelProductsIcon';
import BoxLabelPrintingIcon from 'images/icons/components/boxLabelPrintingIcon';
import BoxLabelScanIcon from 'images/icons/components/boxLabelScanIcon';

const ALL_STATUSES = ['EXPIRED', 'ON_DATE', 'VALID'];

function MobileHome({ userInfo }) {
  const history = useHistory();
  const { id: paramsID } = useParams();
  const environment = Environment(process.env.REACT_APP_ENV);
  const [validityCards, setValidityCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalSettings, setModalSettings] = useState([
    {
      id: 1,
      name: 'writeOffReleases',
      open: false,
      fullScreen: false,
      maxWidth: 'md',
      products: []
    },
    {
      id: 2,
      name: 'productTransference',
      open: false,
      fullScreen: false,
      maxWidth: 'md'
    },
    {
      id: 3,
      name: 'labelPrintConfigDialog',
      open: false,
      product: null
    },
    {
      id: 4,
      name: 'printQrCodeScannerDialog',
      open: false
    }
  ]);

  const [toastProps, setToastProps] = useState({});
  const [toastOpen, setToastOpen] = useState(false);
  const [message, setMessage] = useState({ description: '', status: '' });

  const printLabel = async (product, isReprint = false) => {
    try {
      const response = await Axios.post(
        `${environment.catalog}/printer/products/labels`,
        {
          ...(isReprint && { labelId: product?.id }),
          restaurantId: paramsID,
          productId: isReprint ? product?.productId : product?.id,
          quantity: product?.quantity,
          numberOfLabels: product?.numberOfLabels,
          user: userInfo?.user
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      setModalSettings(
        modalSettings.map((modal) =>
          modal.name === 'labelPrintConfigDialog'
            ? { ...modal, open: false, product: null }
            : modal
        )
      );

      setMessage({
        description: 'Solicitação de impressão enviada',
        status: 'success'
      });
      return response.data;
    } catch (error) {
      setMessage({
        description: 'Erro ao imprimir etiqueta',
        status: 'error'
      });
      throw error;
    }
  };

  const getData = async () => {
    setLoading(true);
    try {
      const res = await Axios.get(
        `${environment.catalog}/printer/products/labels`,
        {
          params: { restaurantId: paramsID }
        }
      );

      const responseData = res?.data || [];

      const mergedData = ALL_STATUSES?.map((status) => {
        const found = responseData?.find(
          (item) => item?.labelStatus === status
        );
        return {
          labelStatus: status,
          total: found?.total || 0
        };
      });

      setValidityCards(mergedData);
    } catch (error) {
      setMessage(
        error?.response?.data || {
          description: 'Erro ao carregar dados',
          status: 'error'
        }
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [paramsID]);

  return (
    <Layout>
      <GlobalStyle />

      <TitleHead title="Home" />

      <Container className="homeInfosPage homeDistance">
        <div className="menuContainer w100">
          <Typography className="title justifyStart dFlex mb10">
            O QUE PRECISA FAZER AGORA?
          </Typography>

          <div className="menuButtonsContainer">
            <IconButton
              className="p0 iconButton"
              edge="start"
              color="inherit"
              onClick={() => history.push(`/producao/${paramsID}`)}
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <BoxProduceIcon
                primaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#E5AD5C'
                    : '#5062F0'
                }
                secondaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#000000'
                    : '#FFF'
                }
              />
            </IconButton>

            <IconButton
              className="p0 iconButton"
              edge="start"
              color="inherit"
              onClick={() => history.push(`/inventario/contagens/${paramsID}`)}
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <BoxCountIcon
                primaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#E5AD5C'
                    : '#5062F0'
                }
                secondaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#000000'
                    : '#FFF'
                }
              />
            </IconButton>

            <IconButton
              className="p0 iconButton"
              edge="start"
              color="inherit"
              onClick={() => history.push(`/recebimento/${paramsID}`)}
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <BoxToReceiveIcon
                primaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#E5AD5C'
                    : '#5062F0'
                }
                secondaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#000000'
                    : '#FFF'
                }
              />
            </IconButton>

            <IconButton
              className="p0 iconButton"
              edge="start"
              color="inherit"
              onClick={() =>
                setModalSettings(
                  modalSettings.map((modal) =>
                    modal.name === 'writeOffReleases'
                      ? { ...modal, open: true }
                      : modal
                  )
                )
              }
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <BoxDropCasualtiesIcon
                primaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#E5AD5C'
                    : '#5062F0'
                }
                secondaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#000000'
                    : '#FFF'
                }
              />
            </IconButton>

            <IconButton
              className="p0 iconButton"
              edge="start"
              color="inherit"
              onClick={() =>
                setModalSettings(
                  modalSettings.map((modal) =>
                    modal.name === 'productTransference'
                      ? { ...modal, open: true }
                      : modal
                  )
                )
              }
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <BoxTransferIcon
                primaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#E5AD5C'
                    : '#5062F0'
                }
                secondaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#000000'
                    : '#FFF'
                }
              />
            </IconButton>
          </div>
        </div>

        <div className="menuContainer w100 mt50">
          <Typography className="title justifyStart dFlex mb10">
            IMPRESSÃO DE ETIQUETAS
          </Typography>

          <div className="menuButtonsContainer">
            <IconButton
              className="p0 iconButton"
              edge="start"
              color="inherit"
              onClick={() =>
                history.push(`/etiquetas/catalogo/produtos/${paramsID}`)
              }
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <BoxLabelProductsIcon
                primaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#E5AD5C'
                    : '#5062F0'
                }
                secondaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#000000'
                    : '#FFF'
                }
              />
            </IconButton>

            <IconButton
              className="p0 iconButton"
              edge="start"
              color="inherit"
              onClick={() => {
                setModalSettings(
                  modalSettings.map((modal) =>
                    modal.name === 'labelPrintConfigDialog'
                      ? { ...modal, open: true }
                      : modal
                  )
                );
              }}
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <BoxLabelPrintingIcon
                primaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#E5AD5C'
                    : '#5062F0'
                }
                secondaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#000000'
                    : '#FFF'
                }
              />
            </IconButton>

            <IconButton
              className="p0 iconButton"
              edge="start"
              color="inherit"
              onClick={() => {
                setModalSettings(
                  modalSettings.map((modal) =>
                    modal.name === 'printQrCodeScannerDialog'
                      ? { ...modal, open: true }
                      : modal
                  )
                );
              }}
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <BoxLabelScanIcon
                primaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#E5AD5C'
                    : '#5062F0'
                }
                secondaryColor={
                  userInfo?.whiteLabel === 'CHINA'
                    ? '#000000'
                    : '#FFF'
                }
              />
            </IconButton>
          </div>
        </div>

        {/* <ValidityProductCards
          data={validityCards}
          loading={loading}
          customClassName="mobileHomeValidityCards"
          hideLabels
        /> */}
      </Container>

      {modalSettings?.find((modal) => modal.name === 'writeOffReleases')
        .open && (
        <Suspense fallback={<span />}>
          <WriteOffReleases
            open={
              modalSettings?.find((modal) => modal.name === 'writeOffReleases')
                .open
            }
            handleClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'writeOffReleases'
                    ? { ...modal, open: false }
                    : modal
                )
              );
            }}
            // userInfo={userInfo}
          />
        </Suspense>
      )}

      {modalSettings?.find((modal) => modal.name === 'productTransference')
        .open && (
        <ProductTransference
          setToastOpen={setToastOpen}
          setToastProps={setToastProps}
          product={
            modalSettings.find((modal) => modal.name === 'productTransference')
              ?.product
          }
          userInfo={userInfo}
          modalSettings={modalSettings}
          setModalSettings={setModalSettings}
          noProduct
          onClose={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'productTransference'
                  ? { ...modal, open: false, product: null }
                  : modal
              )
            );
          }}
        />
      )}

      {modalSettings.find((modal) => modal.name === 'labelPrintConfigDialog')
        ?.open && (
        <LabelPrintConfigDialog
          open={
            modalSettings.find(
              (modal) => modal.name === 'labelPrintConfigDialog'
            )?.open
          }
          onClose={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'labelPrintConfigDialog'
                  ? { ...modal, open: false, product: null }
                  : modal
              )
            );
          }}
          onSubmit={(product, isReprint) => {
            printLabel(product, isReprint);
          }}
          userInfo={userInfo}
        />
      )}

      {modalSettings.find((modal) => modal.name === 'printQrCodeScannerDialog')
        ?.open && (
        <PrintQrCodeScannerDialog
          open={
            modalSettings.find(
              (modal) => modal.name === 'printQrCodeScannerDialog'
            )?.open
          }
          onClose={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'printQrCodeScannerDialog'
                  ? { ...modal, open: false, product: null }
                  : modal
              )
            );
          }}
          onDetected={async (productId) => {
            try {
              const response = await Axios.get(
                `${environment.catalog}/printer/products/${productId}`,
                {
                  params: { restaurantId: paramsID }
                }
              );

              const data = response.data;

              setModalSettings((prev) =>
                prev.map((modal) => {
                  if (modal.name === 'printQrCodeScannerDialog') {
                    return { ...modal, open: false, product: null };
                  }

                  if (modal.name === 'labelPrintConfigDialog') {
                    return { ...modal, open: true, product: data };
                  }

                  return modal;
                })
              );
            } catch (error) {
              setMessage({
                description: 'Erro ao buscar produto',
                status: 'error'
              });
            }
          }}
        />
      )}

      <CommonAlert
        open={toastOpen}
        onClose={() => setToastOpen(false)}
        severity={toastProps.severity}
        indexMessage={toastProps.message}
        messagePersonal={toastProps.message}
      />

      <CommonAlert
        open={message?.description}
        onClose={() => setMessage({ description: '', status: '' })}
        severity={message?.status}
        indexMessage={message?.description}
        messagePersonal={message?.description}
      />
    </Layout>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MobileHome);
